import {Component, effect, inject, input} from '@angular/core'
import {BaseTable, BindingPipe} from '@sparbanken-syd/sparbanken-syd-theme'
import {IInterestRow} from '../../../0-application/types'
import {
  MatCell,
  MatCellDef,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderCellDef,
  MatHeaderRow,
  MatHeaderRowDef,
  MatRow,
  MatRowDef,
  MatTable
} from '@angular/material/table'
import {Configuration, fromColumn} from '../../../services/configuration'
import {DecimalPipe} from '@angular/common'
import {color} from '../../../2-home/10-test/test'

@Component({
  selector: 'spb-derived-table',
  imports: [
    BindingPipe,
    MatCell,
    MatCellDef,
    MatColumnDef,
    MatHeaderCell,
    MatHeaderRow,
    MatHeaderRowDef,
    MatRow,
    MatRowDef,
    MatTable,
    MatHeaderCellDef,
    DecimalPipe
  ],
  templateUrl: './derived-table.html',
  styleUrl: './derived-table.scss'
})
export class DerivedTable extends BaseTable<IInterestRow> {

  // The data.
  public interests = input.required<IInterestRow[]>()

  public ltvs = ['50', '55', '60', '65', '70', '75', '80', '85', '90', '100']

  public configuration = inject(Configuration)

  constructor() {
    super()
    this.columns.set(['name', ...this.ltvs])

    effect(() => {
      this.items.data = this.interests()
    })
  }

  public color = color

  public internalInterest(product: string, binding: number, ltv: number) {
    return this.configuration.internalInterest(product, fromColumn[binding], ltv)
  }

  public productionPrice(binding: number, ltv: number) {
    return this.configuration.productionPriceLtv(fromColumn[binding], ltv)
  }

  /**
   * The difference between the Internal and Production and Discount.
   * Unless fiddle with this should come out as zero. If the production
   * prices are fiddled with then this will diverge from zero.
   */
  public diff(productId: string, binding: number, ltv: number) {
    const internalInterest = this.internalInterest(productId, binding, ltv)
    const productionPrice = this.productionPrice(binding, ltv)
    const diff = internalInterest - productionPrice - this.configuration.discount()
    return Math.round((diff + Number.EPSILON) * 1000) / 1000
  }
}
